<template>
    <b-card no-body>
        <b-card-header class="border-0">
            <h3 class="mb-0">{{$t('plantas')}}</h3>
        </b-card-header>

        <el-table class="table-responsive table" header-row-class-name="thead-light" :data="plantas">
            <el-table-column :label="$t('nombre')" prop="budget" min-width="40px">
                <template v-slot="{ row }">
                    <span class="status">{{ row.nombre }}</span>
                </template>
            </el-table-column>

            <el-table-column :label="$t('empresa')" min-width="60px" prop="empresa">
                <template v-slot="{ row }">
                    <span class="empresa">{{ row.empresa || 'Inexlink' }}</span>
                </template>
            </el-table-column>

            <el-table-column :label="$t('direccion')" min-width="50px" prop="direccion">
                <template v-slot="{ row }">
                    <span class="direccion">{{ row.direccion }}</span>
                </template>
            </el-table-column>

            <el-table-column :label="$t('ciudad')" min-width="40px" prop="ciudad">
                <template v-slot="{ row }">
                    <span class="ciudad">{{ row.ciudad }}</span>
                </template>
            </el-table-column>

            <el-table-column :label="$t('pais')" min-width="40px" prop="pais">
                <template v-slot="{ row }">
                    <span class="pais">{{ row.pais }}</span>
                </template>
            </el-table-column>

            <el-table-column :label="$t('accion')" min-width="40px" prop="action">
                <template v-slot="{ row }">
                    <b-row>
                        <b-col>
                            <router-link :to="{ name: 'planta-detalle', params: { id: row.id } }">
                                <a variant="primary" class="btn-create-new">
                                    <i class="fas fa-eye"></i>
                                </a>
                            </router-link>
                        </b-col>
                        <b-col>
                            <a @click="deleteRow(row.id)" variant="primary" class="btn-create-new">
                                <i class="fas fa-trash" style="color: red; cursor: pointer;"></i>
                            </a>
                        </b-col>
                    </b-row>
                </template>
            </el-table-column>
        </el-table>

        <!-- <b-card-footer class="py-4 d-flex justify-content-end">
            <base-pagination v-model="currentPage" :per-page="10" :total="50"></base-pagination>
        </b-card-footer> -->
    </b-card>
</template>
<script>
import plantaService from '@/api/plantaService';
import { Table, TableColumn } from 'element-ui'
import utilsService from '@/api/utilsService';

export default {
    name: 'planta-table',
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    computed: {
        rol() {
            return utilsService.getRol();
        }
    },
    data() {
        return {
            plantas: [],
            currentPage: 1
        };
    },
    async beforeMount() {
        try {
            this.plantas = await plantaService.getAll();
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    },
    methods: {
        deleteRow(id) {
            Swal.fire({
                title: this.$t('estas_seguro'),
                text: this.$t('confirma_eliminar'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: this.$t('si_eliminar'),
                cancelButtonText: this.$t('cancelar')
            }).then(async (result) => {
                if (result.isConfirmed) {

                    Swal.fire({
                        html: `<div style="display: flex; align-items: center; justify-content: center;"> 
                      <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
                        <div>
                            <h3 style="color: #006393;">Eliminando...</h3>
                        </div>
                    </div>`,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    });

                    const response = await plantaService.deleteBy(id);
                    if (!response) {
                        Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: this.$t('error')
                        });
                        return;
                    }
                    this.plantas = await plantaService.getAll();

                    Swal.fire({
                        text: this.$t('eliminado_correctamente'),
                        icon: "success",
                        showConfirmButton: false,
                        timer: 2000,
                        background: '#f8f9fa',
                        customClass: {
                            title: 'swal-title',
                            icon: 'swal-icon',
                        },
                    });
                }
            });

        },
    }
}
</script>
<style>
</style>